import { AUTH_SUCCESS, AUTH_FAIL } from '../types'

const initialState = {
    authenticated: false,
    user: {}
}

const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTH_SUCCESS:
            return {
                ...state,
                authenticated: true,
                user: action.payload
            }
        case AUTH_FAIL:
            return {
                ...state,
                authenticated: false,
                user: {}
            }
        default:
            return state
    }
}

export default authReducer;



// WEBPACK FOOTER //
// ./src/reducers/auth-reducer.js